import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";

const STEPS = [
  "Birth profile created",
  "Chart calculated",
  "Relevant periods identified",
  "Your reading is being prepared",
];

export default function Generating() {
  const location = useLocation();
  const navigate = useNavigate();
  const [done, setDone] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const payload = location.state?.payload;
    if (!payload) {
      navigate("/", { replace: true });
      return;
    }
    if (started.current) return;
    started.current = true;

    const interval = setInterval(() => setDone((d) => Math.min(d + 1, STEPS.length - 1)), 850);
    const t0 = Date.now();

    api.post("/readings/generate", payload)
      .then(({ data }) => {
        const wait = Math.max(0, 3200 - (Date.now() - t0));
        setTimeout(() => {
          clearInterval(interval);
          setDone(STEPS.length);
          setTimeout(() => navigate(`/teaser/${data.reading_id}`, { replace: true }), 500);
        }, wait);
      })
      .catch(() => {
        clearInterval(interval);
        toast.error("We couldn't create your reading. Please try again.");
        navigate(-1);
      });

    return () => clearInterval(interval);
  }, []); // eslint-disable-line

  return (
    <div className="jaanlo-grain flex min-h-[80vh] flex-col items-center justify-center px-6">
      <div className="relative mb-10">
        <div className="h-20 w-20 rounded-full bg-gold-soft" />
        <Loader2 className="absolute inset-0 m-auto h-10 w-10 animate-spin gold-text" />
      </div>
      <h1 className="font-display text-2xl font-semibold tracking-tight md:text-3xl" data-testid="generating-title">
        Creating your personalized reading…
      </h1>
      <div className="mt-10 w-full max-w-sm space-y-4">
        {STEPS.map((s, i) => {
          const complete = i < done;
          const active = i === done;
          return (
            <div key={s} className={`flex items-center gap-3 transition-opacity duration-500 ${i <= done ? "opacity-100" : "opacity-30"}`}>
              <span className={`flex h-6 w-6 items-center justify-center rounded-full ${complete ? "bg-foreground text-background" : "border border-border"}`}>
                {complete ? <Check className="h-3.5 w-3.5" /> : active ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : null}
              </span>
              <span className={`text-sm ${active ? "shimmer font-medium" : ""}`}>{s}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
